import { useMemo } from 'react';
import { useAuth } from '../utils/AuthContext';
import { useCRM } from '../utils/CRMContext';
import {
  canAccessContractorTimesheets,
  canEnterContractorTimeOnBehalf,
  resolveIs1099Contractor,
} from '../utils/contractorPayablesAccess';

/** Contractor timesheet page + nav access, with CRM hydration fallback for is1099Contractor. */
export function useContractorTimesheetAccess() {
  const { user } = useAuth();
  const { crmUsers } = useCRM();

  const me = useMemo(
    () => crmUsers.find((u) => u.uid === user?.id),
    [crmUsers, user?.id],
  );

  const designations = user?.designations ?? me?.designations;

  const is1099Contractor = resolveIs1099Contractor({
    authFlag: user?.is1099Contractor,
    crmFlag: me?.is1099Contractor,
  });

  const canAccess = canAccessContractorTimesheets({
    authRole: user?.role,
    designations,
    is1099Contractor,
  });

  const canOnBehalf = canEnterContractorTimeOnBehalf({
    authRole: user?.role,
    designations,
  });

  return { canAccess, canOnBehalf, is1099Contractor };
}
